import { apiClient } from '../utils/api-client';

export interface GymNotificationPreference {
  notification_type: 'new_climb' | 'first_top' | 'new_announcement';
  push_enabled: boolean;
  email_enabled: boolean;
}

interface GymNotificationPreferencesResponse {
  data: GymNotificationPreference[];
}

class GymNotificationPreferencesService {
  async getPreferences(gymSlug: string): Promise<GymNotificationPreference[]> {
    const response = await apiClient.get(
      `/api/gyms/${gymSlug}/notification_preferences`,
      { requireAuth: true }
    );
    if (!response.ok) throw new Error('Failed to fetch gym notification preferences');
    const json: GymNotificationPreferencesResponse = await response.json();
    return json.data;
  }

  async updatePreferences(gymSlug: string, preferences: GymNotificationPreference[]): Promise<void> {
    const response = await apiClient.patch(
      `/api/gyms/${gymSlug}/notification_preferences`,
      { data: { preferences } },
      { requireAuth: true }
    );
    if (!response.ok) throw new Error('Failed to update gym notification preferences');
  }
}

export const gymNotificationPreferencesService = new GymNotificationPreferencesService();
